import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LemonWire from "@/pages/LemonWire";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LemonWire />} />
          <Route path="*" element={<LemonWire />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
